import { Routes, Route } from "react-router-dom";
import { AuthClientTokens } from "model/auth.type";
import { ListRoutes } from "router/routes";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import HomePage from "component/HomePage";
import { keycloak } from "service/keycloakService";
import AddPage from "component/AddPage";
import { ScreenNotFound } from "components/NotFound";
import { useDispatch } from "react-redux";
import { departmentsActions } from "component/AddPage/slice";

const initOptions = {
  onLoad: "login-required",
  silentCheckSsoRedirectUri: window.location.origin + window.location.pathname,
  checkLoginIframe: false,
  "bearer-only": true,
  "ssl-required": "external",
  "enable-cors": true,
  enableLogging: true,
};

export default function MainRoute() {
  const dispatch = useDispatch();

  const eventLogger = (event: unknown, error: unknown) => {
    // console.log("onKeycloakEvent", event, error);
  };

  const tokenLogger = (tokens: AuthClientTokens) => {
    if (tokens?.token) {
      dispatch(departmentsActions.setTokenInfo(tokens.token));
    }
  };

  return (
    <div className="App">
      <Routes>
        <Route path={ListRoutes.HOME} element={<HomePage />} />
        <Route
          path={ListRoutes.ADD_PAGE}
          element={
            <ReactKeycloakProvider
              initOptions={initOptions}
              authClient={keycloak}
              onEvent={eventLogger}
              onTokens={tokenLogger}
              autoRefreshToken
            >
              <AddPage />
            </ReactKeycloakProvider>
          }
        />
        <Route path={ListRoutes.ALL} element={<ScreenNotFound />} />
      </Routes>
    </div>
  );
}
